(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-discount-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const context = document.getElementById('ss-discount-context');
  if (!context || window.SSDiscountPricing) return;
  const root = `${context.dataset.root.replace(/\/$/, '')}/`;
  const business = context.dataset.business === 'true';
  const allowed = new Set(context.dataset.codes.split(','));
  let cart = null;
  let readPromise = null;
  let generation = 0;
  let mutationQueue = Promise.resolve();
  let tradeCheckPromise = null;
  let checkoutPending = false;
  let tradeError = false;
  const approvedForms = new WeakSet();
  const subscribers = new Set();
  // Bundled section rendering replaces the field node after every cart mutation.
  // Keep its feedback by stable input id so the replacement preserves the result.
  const fieldFeedback = new Map();
  const normalize = value => String(value || '').trim().toLowerCase();
  const cartCodes = value => Array.isArray(value?.discount_codes) ? value.discount_codes : [];
  const activeCode = () => business ? '' : normalize(cartCodes(cart).find(item => item.applicable === true && allowed.has(normalize(item.code)))?.code);
  const update = value => {
    if (!value || !Array.isArray(value.items)) return;
    cart = value;
    for (const subscriber of subscribers) subscriber();
  };
  const request = async (path, options = {}) => {
    const response = await fetch(root + path, { credentials: 'same-origin', cache: 'no-store', ...options });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  };
  const hasCodes = value => cartCodes(value).some(item => normalize(item.code));
  const showTradeError = failed => {
    tradeError = failed;
    for (const message of document.querySelectorAll('[data-ss-trade-error]')) message.hidden = !failed;
  };
  const checkTradeCart = () => {
    if (tradeCheckPromise) return tradeCheckPromise;
    const task = async () => {
      generation += 1;
      let result = await request('cart.js');
      if (!Array.isArray(result?.items)) throw new Error('Invalid cart response');
      const needsRemoval = hasCodes(result);
      if (needsRemoval) {
        result = await request('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) });
        if (!Array.isArray(result?.items) || hasCodes(result)) throw new Error('Discount removal failed');
      }
      generation += 1;
      update(result);
      showTradeError(false);
      if (needsRemoval && !checkoutPending) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (location.pathname.replace(/\/$/, '') === `${root}cart`.replace(/\/$/, '')) location.reload();
      }
      return result;
    };
    tradeCheckPromise = mutationQueue.then(task, task).catch(error => {
      showTradeError(true);
      throw error;
    }).finally(() => { tradeCheckPromise = null; });
    mutationQueue = tradeCheckPromise.catch(() => {});
    return tradeCheckPromise;
  };
  const refresh = () => {
    if (business) return checkTradeCart().catch(() => null);
    if (readPromise) return readPromise;
    const ticket = generation;
    readPromise = request('cart.js').then(value => {
      if (ticket === generation) update(value);
      return value;
    }).catch(() => {
      if (ticket === generation) update({ items: [], discount_codes: [] });
      return null;
    }).finally(() => { readPromise = null; });
    return readPromise;
  };
  const mutate = transform => {
    if (business) return checkTradeCart();
    const task = async () => {
      generation += 1;
      const current = await request('cart.js');
      const codes = transform(cartCodes(current).map(item => normalize(item.code)).filter(Boolean));
      const result = await request('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: [...new Set(codes)].join(',') }) });
      generation += 1;
      update(result);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return result;
    };
    const pending = mutationQueue.then(task, task);
    mutationQueue = pending.catch(() => {});
    return pending;
  };
  window.SSDiscountPricing = { refresh, activeCode, getCart: () => cart };
  class SSDiscountPrice extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        if (!this.isConnected) return;
        const mode = activeCode() ? 'code' : 'base';
        if (this.mode === mode) return;
        const output = this.querySelector('[data-ss-price-display]');
        const template = this.querySelector(`[data-ss-price-${mode}]`);
        if (!output || !template) return;
        output.replaceChildren(template.content.cloneNode(true));
        this.mode = mode;
      };
      subscribers.add(this.update);
      this.update();
    }
    disconnectedCallback() { subscribers.delete(this.update); }
  }
  class DiscountField extends HTMLElement {
    connectedCallback() {
      if (business) { this.replaceChildren(); this.hidden = true; return; }
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.input = this.querySelector('input');
      this.button = this.querySelector('[data-ss-apply]');
      this.message = this.querySelector('[data-ss-message]');
      this.list = this.querySelector('[data-ss-codes]');
      this.input?.addEventListener('input', () => {
        fieldFeedback.delete(this.input.id);
        this.show('');
        this.input.removeAttribute('aria-invalid');
      }, options);
      this.button?.addEventListener('click', () => this.apply(), options);
      this.input?.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.apply(); } }, options);
      this.addEventListener('click', event => {
        const remove = event.target.closest('[data-ss-remove-code]');
        if (remove) { event.preventDefault(); this.removeCode(remove.dataset.ssRemoveCode); }
      }, options);
      this.update = () => this.renderCodes();
      subscribers.add(this.update);
      this.renderCodes();
      this.renderFeedback();
    }
    disconnectedCallback() { this.abort?.abort(); subscribers.delete(this.update); }
    renderFeedback() {
      const state = fieldFeedback.get(this.input?.id);
      if (!state || !this.input || !this.button) return;
      this.input.value = state.value;
      this.input.disabled = state.busy;
      this.button.disabled = state.busy;
      this.setAttribute('aria-busy', state.busy ? 'true' : 'false');
      if (state.error) this.input.setAttribute('aria-invalid', 'true');
      else this.input.removeAttribute('aria-invalid');
      this.show(state.message, state.error);
    }
    setFeedback(message, error, value, busy = false) {
      if (!this.input?.id) return;
      fieldFeedback.set(this.input.id, { message, error, value, busy });
      this.renderFeedback();
      for (const field of document.querySelectorAll('discount-field')) {
        if (field !== this && field.input?.id === this.input.id) field.renderFeedback();
      }
    }
    renderCodes() {
      if (!this.list) return;
      this.list.replaceChildren();
      for (const item of cartCodes(cart).filter(entry => entry.applicable === true)) {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.ssRemoveCode = item.code;
        button.textContent = `${item.code} ×`;
        button.setAttribute('aria-label', `${this.dataset.remove}: ${item.code}`);
        this.list.appendChild(button);
      }
    }
    show(message, error = false) {
      if (!this.message) return;
      this.message.textContent = message;
      this.message.classList.toggle('text-error', error);
    }
    async apply() {
      if (business || this.busy) return;
      const code = normalize(this.input?.value);
      if (!code) return;
      const entered = this.input.value;
      this.busy = true;
      this.setFeedback('', false, entered, true);
      try {
        const result = await mutate(codes => [...codes.filter(existing => !allowed.has(existing) || !allowed.has(code)), code]);
        const accepted = cartCodes(result).some(item => normalize(item.code) === code && item.applicable === true);
        if (!accepted) {
          this.setFeedback(result.item_count === 0 ? this.dataset.empty : this.dataset.error, true, entered);
        } else {
          this.setFeedback(this.dataset.success, false, '');
        }
        if (accepted && location.pathname.replace(/\/$/, '') === `${root}cart`.replace(/\/$/, '')) location.reload();
      } catch { this.setFeedback(this.dataset.error, true, entered); }
      finally { this.busy = false; }
    }
    async removeCode(code) {
      if (this.busy) return;
      this.busy = true;
      this.setFeedback('', false, this.input?.value || '', true);
      try {
        await mutate(codes => codes.filter(existing => existing !== normalize(code)));
        this.setFeedback('', false, '');
        if (location.pathname.replace(/\/$/, '') === `${root}cart`.replace(/\/$/, '')) location.reload();
      } catch { this.setFeedback(this.dataset.error, true, this.input?.value || ''); }
      finally { this.busy = false; }
    }
  }
  class DiscountBadge extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.querySelector('[data-close]')?.addEventListener('click', event => {
        event.preventDefault();
        document.querySelector('discount-field')?.removeCode(this.dataset.code);
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  if (!customElements.get('ss-discount-price')) customElements.define('ss-discount-price', SSDiscountPrice);
  if (!customElements.get('discount-field')) customElements.define('discount-field', DiscountField);
  if (!customElements.get('discount-badge')) customElements.define('discount-badge', DiscountBadge);
  if (business) document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || action.pathname.replace(/\/$/, '') !== `${root}cart`.replace(/\/$/, '')) return;
    const submitter = event.submitter || form.querySelector('[name="checkout"]');
    if (submitter?.name !== 'checkout') return;
    if (approvedForms.has(form)) { approvedForms.delete(form); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    submitter.setAttribute('aria-busy', 'true');
    try {
      await checkTradeCart();
      if (form.isConnected) {
        approvedForms.add(form);
        form.requestSubmit(submitter);
      }
    } catch { showTradeError(true); }
    finally { approvedForms.delete(form); checkoutPending = false; submitter.removeAttribute('aria-busy'); }
  }, true);
  document.addEventListener('cart:change', event => {
    if (business) { refresh(); return; }
    generation += 1;
    if (event.detail?.cart?.discount_codes) update(event.detail.cart);
    else refresh();
  });
  document.addEventListener('cart:refresh', () => { refresh(); });
  document.addEventListener('shopify:section:load', () => { if (business) showTradeError(tradeError); refresh(); });
  window.addEventListener('pageshow', () => { refresh(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
